import { OrderIndData, OrderIndListData } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageData, PageDataStatus, FetchStateType, getFetchStateChange } from "../../models";


type IOrderINdData = {
	all?: OrderIndListData[];
	displayData?: OrderIndListData[];
	floatingData?: OrderIndListData[];
	currentPage?: PageData<OrderIndListData>;
	displayedOrderInd?: OrderIndData;
	fetchState: FetchStateType;
	cancelFetchState: FetchStateType;
	downloadOrderIndFetchState: FetchStateType;
};

const initialState: IOrderINdData = {
	all: [],
	displayData: [],
	floatingData: [],
	cancelFetchState: { type: "not-started" },
	fetchState: { type: "not-started" },
	downloadOrderIndFetchState: { type: "not-started" },
};


const name = "orderind";

const orderIndSlice = createSlice({
	name,
	initialState,
	reducers: {
		setorderInd: (state, action: PayloadAction<PageData<OrderIndListData>>) => ({
			...state,
			currentPage: action.payload,
		}),

		setDisplayed: (state, action: PayloadAction<OrderIndData | undefined>) => ({
			...state,
			displayedOrderInd: action.payload,
		}),

		setFloatingOrderInd: (state, action: PayloadAction<OrderIndListData[]>) => ({
			...state,
			floatingData: action.payload,
		}),

		invalidateorderInd: state => {
			if (!state.currentPage) return state;

			return {
				...state,
				currentPage: {
					...state.currentPage,
					status: PageDataStatus.DataInvalidated,
				},
			};
		},
		setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			displayedOrderInd: action.payload.type === "successful" ? undefined : state.displayedOrderInd,
			//			all: action.payload.type === "successful" ? undefined : state.all,
			//			displayData: action.payload.type === "successful" ? undefined : state.displayData,
			fetchState: getFetchStateChange(state.fetchState, action.payload),
		}),
		setCancelorderIndFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			cancelFetchState: action.payload,
		}),
		setDownloadorderIndFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			downloadOrderIndFetchState: action.payload,
		}),
	},
});

export const {
	setorderInd,
	setDisplayed,
	setFloatingOrderInd,
	invalidateorderInd,
	setFetchState,
	setCancelorderIndFetchState,
	setDownloadorderIndFetchState,
} = orderIndSlice.actions;

export default orderIndSlice.reducer;



